export default __webpack_public_path__ + "static/media/libros.3cd483ab.png";